// Service pages where the feature is disabled.
// Uses startsWith matching after locale-prefix normalization.
const SERVICE_PAGE_PREFIXES = [
  '/login',
  '/register',
  '/password',
  '/email',
  '/panel',
  '/under-construction'
]

function normalizePath(path: string): string {
  return path.replace(/^\/[a-z]{2}(\/|$)/, '/')
}

function isServicePage(path: string): boolean {
  const normalized = normalizePath(path)
  return SERVICE_PAGE_PREFIXES.some((prefix) => normalized.startsWith(prefix))
}

export function useTypoReport() {
  const route = useRoute()
  const isDialogOpen = ref(false)
  const selectedText = ref('')

  function getSelectionText(): string {
    const selection = window.getSelection()
    if (!selection) return ''
    return selection.toString().trim()
  }

  function tryOpenDialog() {
    if (isServicePage(route.path)) return
    if (isDialogOpen.value) return // ignore if dialog already open

    const text = getSelectionText()
    if (!text) return

    selectedText.value = text.slice(0, 5000) // silently truncate to backend limit
    isDialogOpen.value = true
  }

  function closeDialog() {
    isDialogOpen.value = false
    selectedText.value = ''
  }

  function onKeydown(e: KeyboardEvent) {
    const isCtrlEnter = (e.ctrlKey || e.metaKey) && e.key === 'Enter'
    if (!isCtrlEnter) return
    tryOpenDialog()
  }

  onMounted(() => {
    document.addEventListener('keydown', onKeydown)
  })

  onUnmounted(() => {
    document.removeEventListener('keydown', onKeydown)
  })

  // Auto-close dialog and clear state on route change
  watch(
    () => route.path,
    () => closeDialog()
  )

  return {
    isDialogOpen,
    selectedText,
    tryOpenDialog,
    closeDialog,
    isServicePageActive: () => isServicePage(route.path),
    getSelectionText
  }
}
